module.exports = {"environment":{"environment":"R6-Prod","version":"6_100_3145"}};